export default __webpack_public_path__ + "static/snippet-icon-0b0be358c652676fa7c3d818cce0f0a7.svg";